import api from './api'
import { API_ENDPOINTS } from '../config/api'

const userService = {
  getAllDetails: async (page = 1, limit = 25, search = '', { exact, parentId } = {}) => {
    const params = { page, limit }
    if (exact) {
      params.exact = exact
    } else if (search) {
      params.search = search
    }
    // Drill-down: is staff (parentId = staff_id) ke direct downline dikhao
    if (parentId) {
      params.parentId = parentId
    }
    const response = await api.get(API_ENDPOINTS.USER.ALL_DETAILS, { params })
    return response.data
  },
  // Live availability check — server status code se jawaab deta hai
  // (200 = available, 202 = taken), isliye caller ko poora response chahiye,
  // sirf data nahi. skipLoader: har keystroke pe global loader flash na ho.
  checkUsername: async (username, signal) => {
    return api.get(API_ENDPOINTS.USER.CHECK_USERNAME, {
      params: { username },
      signal,
      skipLoader: true,
    })
  },
  createUser: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.CREATE_USER, data)
    return response.data
  },
  createStaff: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.CREATE_STAFF, data)
    return response.data
  },
  updateStatusAndPassword: async (data) => {
    const response = await api.put(API_ENDPOINTS.USER.UPDATE_STATUS_PASSWORD, data)
    return response.data
  },
  // Per-game JS Game Lock (S popup). type = 'USER' | 'STAFF'.
  getJsGameLocks: async (type, id) => {
    const response = await api.get(`/admin/js-game-lock/${type}/${id}`)
    return response.data
  },
  searchJsGames: async (q) => {
    const response = await api.get('/admin/js-game-lock/search', { params: { q } })
    return response.data
  },
  // { user_type, id, game_uids[], transactionPassword } — replaces the account's own lock set
  updateJsGameLocks: async (data) => {
    const response = await api.put('/admin/js-game-lock', data)
    return response.data
  },
  // Exposure limit — sirf apne DIRECT downline (user ya staff) ki set hoti hai.
  // Value Wallets.exposure_limit par jaati hai; 0 = koi limit nahi.
  updateExposureLimit: async (data) => {
    const response = await api.post('/admin/user-settings/exposure-limit', data)
    return response.data
  },
  updateLoggedInStaffPassword: async (data) => {
    const response = await api.put('/admin/staff-update-password', data)
    return response.data
  },
  updateOwnerPassword: async (data) => {
    const response = await api.put('/admin/owner/update-password', data)
    return response.data
  }
}

export default userService
